import React from 'react';
import './App.css';
import { useLeaderboard } from './hooks/useLeaderboard';
import { useStreamStatus } from './hooks/useStreamStatus';
import LiveSection from './components/LiveSection';
import About from './components/About';
import Payouts from './components/Payouts';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Rewards from './components/Rewards';
import HowItWorks from './components/HowItWorks';
import Leaderboard from './components/Leaderboard';
import VIP from './components/VIP';
import FAQ from './components/FAQ';
import Community from './components/Community';
import Footer from './components/Footer';
import AgeGate from './components/AgeGate';
import MobileCTA from './components/MobileCTA';

function Home() {
  const lb = useLeaderboard();
  const stream = useStreamStatus();
  return (
    <div className="App">
      <a href="#main" className="skip-link">Skip to content</a>
      <AgeGate />
      <div className="ar-bg-ambient" />
      <div className="ar-bg-grid" />
      <Navbar stream={stream} />
      <main id="main">
        <Hero lb={lb} />
        <LiveSection stream={stream} />
        <About />
        <Leaderboard lb={lb} />
        <HowItWorks />
        <Payouts meta={lb.meta} />
        <Rewards />
        <VIP />
        <Community />
        <FAQ />
      </main>
      <Footer />
      <div className="h-20 lg:hidden" aria-hidden="true" />
      <MobileCTA />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
